import { Box, Grid, Typography } from '@mui/material';
import { ThumbsUp } from '@assets/svgs';
import { Suspense } from 'react';
import LazyConfetti from '@components/holiday/LazyConfetti';
import { useEffect, useState } from 'react';

const TWENTY_MINUTES = 20 * 60 * 1000;

export const NoNotifications = () => {
  const [recycleConfetti, setRecycleConfetti] = useState(() => {
    const lastSeenConfetti = localStorage.getItem('lastSeenConfetti');
    if (lastSeenConfetti) {
      const lastSeenTime = new Date(lastSeenConfetti).getTime();
      const currentTime = new Date().getTime();

      return currentTime - lastSeenTime > TWENTY_MINUTES;
    }
    return true;
  });

  useEffect(() => {
    if (recycleConfetti) {
      localStorage.setItem('lastSeenConfetti', new Date().toISOString());
      setRecycleConfetti(true);
    }
  }, [recycleConfetti]);

  return (
    <>
      <Grid
        size={{ xs: 6 }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          margin: '32px',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 84,
            left: 0,
          }}
        >
          {recycleConfetti && (
            <Suspense fallback={null}>
              <LazyConfetti opacity={0.8} numberOfPieces={200} width={500} recycle={false} />
            </Suspense>
          )}
        </Box>

        <ThumbsUp id='thumbsUpIcon' width='27px' height='27px' color={'text.main'} opacity='.6' />
        <Typography variant='bodySmall' fontWeight='bold' color='white100' textAlign='center' marginTop='8px'>
          You have no new notifications at this time
        </Typography>
      </Grid>
    </>
  );
};
